<template>
  <div class="contentbox">
    <!--新增客戶公司-->
    <mt-popup
      v-model="show_add_box"
      :modal="true"
      class="add_subsidiaries_box"
      position="content">
      <slot>
        <div class="signature_box">
          <div class="itme_box">
            <div class="itme">
              <div class="name">客戶公司名稱</div>
              <el-input v-model="add_Client_company.company"></el-input>
            </div>
            <div class="itme">
              <div class="name">公司地址</div>
              <el-input v-model="add_Client_company.address"></el-input>
            </div>
            <div class="itme">
              <div class="name">公司電話</div>
              <el-input v-model="add_Client_company.tel"></el-input>
            </div>
            <div class="itme">
              <div class="name">公司傳真</div>
              <el-input v-model="add_Client_company.fax"></el-input>
            </div>
            <div class="itme">
              <div class="name">公司網址</div>
              <el-input v-model="add_Client_company.website"></el-input>
            </div>
          </div>
          <div class="itme_box" v-for="(itme,index) in contact_person" :key="index">
            <div class="itme">
              <div class="name">聯絡人</div>
              <el-input v-model="itme.customer_liaisons"></el-input>
            </div>
            <div class="itme">
              <div class="name">聯系手機</div>
              <el-input v-model="itme.customer_phone"></el-input>
            </div>
            <div class="itme">
              <div class="name">聯絡人郵箱</div>
              <el-input v-model="itme.customer_email"></el-input>
            </div>
            <div v-if="index === 0"
                 @click="add_contact_person"
                 class="icon">
              <i class="el-icon-plus"></i>
            </div>
            <div v-if="index !== 0"
                 @click="minus_contact_person(index)"
                 class="icon">
              <i class="el-icon-minus"></i>
            </div>
          </div>
          <div class="paymentmethodbut">
            <mt-button @click="show_add_box = false" type="primary">返回</mt-button>
            <mt-button @click="on_add_Client_company" type="primary">确定</mt-button>
          </div>
        </div>
      </slot>
    </mt-popup>
    <div class="conten">
      <div class="personal_settings">
        <div class="title">
          <span></span>
          <span>Equipment</span>
          <!--<i @click="edit_state = true" class="el-icon-edit-outline"></i>-->
          <span></span>
        </div>
        <div class="form_box">
          <ul class="form_ul">
            <li class="form_itme" v-if="$store.state.list_class === 0">
              <div class="itme_name">Location</div>
              <div><el-input v-model="fixedassets_detail.assets_name"></el-input></div>
            </li>
            <li class="form_itme" v-if="$store.state.list_class !== 0">
              <div class="itme_name">名稱</div>
              <div><el-input v-model="fixedassets_detail.assets_name"></el-input></div>
            </li>
            <li class="form_itme">
              <div v-if="$store.state.list_class !== 2" class="itme_name">Serial no</div>
              <div v-if="$store.state.list_class === 2" class="itme_name">序列號</div>
              <div><el-input v-model="fixedassets_detail.assets_machine_number"></el-input></div>
            </li>
            <li class="form_itme">
              <div v-if="$store.state.list_class !== 2" class="itme_name">Brands</div>
              <div v-if="$store.state.list_class === 2" class="itme_name">品牌</div>
              <div class="select_box">
                <el-select v-model="fixedassets_detail.brand_id">
                  <el-option
                    v-for="item in brands_list"
                    :key="item.brand_id"
                    :label="item.brand_name"
                    :value="item.brand_id">
                  </el-option>
                </el-select>
              </div>
            </li>
            <!--<li class="form_itme" v-if="$store.state.list_class === 0">-->
              <!--<div class="itme_name">Customer name</div>-->
              <!--<div class="select_box">-->
                <!--<el-select v-model="fixedassets_detail.assets_type">-->
                  <!--<el-option-->
                    <!--v-for="item in assets_list"-->
                    <!--:key="item.Devicedepartment_id"-->
                    <!--:label="item.Devicedepartment_name"-->
                    <!--:value="item.Devicedepartment_id">-->
                  <!--</el-option>-->
                <!--</el-select>-->
              <!--</div>-->
            <!--</li>-->
            <li class="form_itme">
              <div v-if="$store.state.list_class !== 2" class="itme_name">Model</div>
              <div v-if="$store.state.list_class === 2" class="itme_name">型號</div>
              <div><el-input v-model="fixedassets_detail.assets_model"></el-input></div>
            </li>
            <li class="form_itme">
              <div v-if="$store.state.list_class !== 2" class="itme_name">Description</div>
              <div v-if="$store.state.list_class === 2" class="itme_name">產品描述</div>
              <div><el-input v-model="fixedassets_detail.device_description"></el-input></div>
            </li>
            <li class="form_itme">
              <div v-if="$store.state.list_class !== 2" class="itme_name">Equipment no</div>
              <div v-if="$store.state.list_class === 2" class="itme_name">設備編號</div>
              <div><el-input disabled v-model="fixedassets_detail.assets_num"></el-input></div>
            </li>
            <li class="form_itme">
              <div v-if="$store.state.list_class !== 2" class="itme_name">Warranty end date</div>
              <div v-if="$store.state.list_class === 2" class="itme_name">保修到期日</div>
              <div class="select_box">
                <el-date-picker
                  type="date"
                  v-model="fixedassets_detail.expiry_date"
                  value-format="yyyy-MM-dd"
                  placeholder="請選擇日期">
                </el-date-picker>
              </div>
            </li>
            <li class="form_itme">
              <div v-if="$store.state.list_class !== 2" class="itme_name">Date purchase</div>
              <div v-if="$store.state.list_class === 2" class="itme_name">購買日期</div>
              <div class="select_box">
                <el-date-picker
                  type="date"
                  v-model="fixedassets_detail.assets_buy_time_unix"
                  value-format="yyyy-MM-dd"
                  placeholder="請選擇日期">
                </el-date-picker>
              </div>
            </li>
            <li class="form_itme">
              <div class="itme_name">Company name</div>
              <div class="select_supplier_box select_box">
                <el-select filterable :disabled="$store.state.list_class !== 0" v-model="fixedassets_detail.supplier">
                  <el-option
                    v-for="item in supplier_list"
                    :key="item.company_id"
                    :label="item.company_name"
                    :value="item.company_id">
                  </el-option>
                </el-select>
                <!--<div @click="show_add_box = true" class="add">+NEW 供應商</div>-->
              </div>
            </li>
            <li class="form_itme">
              <div v-if="$store.state.list_class !== 2" class="itme_name">Invoice no</div>
              <div v-if="$store.state.list_class === 2" class="itme_name">發票號碼</div>
              <div><el-input v-model="fixedassets_detail.assets_number"></el-input></div>
            </li>
            <li class="form_itme" v-if="$store.state.list_class === 0">
              <div class="itme_name">Customer type</div>
              <div><el-input v-model="fixedassets_detail.customer_type"></el-input></div>
            </li>
            <!--<li class="form_itme" v-if="$store.state.list_class === 0">-->
              <!--<div class="itme_name">Warranty status</div>-->
              <!--<div><el-input v-model="fixedassets_detail.customerID"></el-input></div>-->
            <!--</li>-->
            <li class="form_itme" v-if="$store.state.list_class === 0">
              <div v-if="$store.state.list_class !== 2" class="itme_name">Supplier</div>
              <div v-if="$store.state.list_class === 2" class="itme_name">供應商</div>
              <div><el-input v-model="fixedassets_detail.customers_name"></el-input></div>
            </li>
            <li class="form_itme" v-if="$store.state.list_class === 0">
              <div class="itme_name">Extend warranty end date</div>
              <div class="select_box">
                <el-date-picker
                  type="date"
                  v-model="fixedassets_detail.extra_due_date"
                  value-format="yyyy-MM-dd"
                  placeholder="請選擇日期">
                </el-date-picker>
              </div>
            </li>
            <li class="form_itme" v-if="$store.state.list_class === 0">
              <div class="itme_name">可查看用户</div>
              <div class="select_box">
                <el-select multiple v-model="fixedassets_detail.userCanSee_id">
                  <el-option
                    v-for="item in operator"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="bottom_but">
        <el-button type="success" @click="save_and_edit">保存</el-button>
        <el-button @click="return_page" type="success">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {MessageBox, Button, Toast} from 'mint-ui';
  import {
    get_fixedassets_detail,
    add_fixedassets,
    getSupplierData,
    get_brands,
    get_assets,
    getServiceUser,
    getLocahost,
    add_customer_company,
  } from '../../assets/js/api'

  export default {
    name: "equipment_details",
    data() {
      return {
        fixedassets_detail:{
          assets_id: "",
          assets_num: "",
          assets_name: "",
          assets_machine_number: "",
          assets_buy_time_unix: "",
          device_description: "",
          expiry_date: "",
          customer_type: "",
          customerID: "",
          customers_name: "",
          extra_due_date: "",
          assets_type: "",
          brand_id: "",
          supplier: "",
          assets_model: "",
          assets_number: "",
          userCanSee_id: [], //可查看人
        },
        supplier_list:[],
        brands_list:[],
        assets_list: 0,//設備類型
        operator: [],//可查看用户
        show_add_box: false,//增加客戶公司窗口
        add_Client_company:{
          company:'',
          address:'',
          tel:'',
          fax:'',
          website:'',
          // 聯絡人
          customer_liaisons:'',
          customer_phone:'',
          customer_email:'',
        },
        contact_person:[
          {
            customer_liaisons:'',
            customer_phone:'',
            customer_email:'',
          }
        ]
      }
    },
    components: {
      MessageBox,
      Button,
      Toast,
    },
    mounted() {
      // 設備類型
      get_assets().then(data=>{
        if (data.status){
          this.assets_list = data.data
        }
      })

      // 獲取品牌
      get_brands().then(data=>{
        if (data.status){
          this.brands_list = data.data
        }
      })

      // 获取服务人员.操作人
      getServiceUser().then(data => {
        if (data.status) {
          this.operator = data.data
        }
      })

      // 获取供应商数据
      getSupplierData().then(data => {
        if (data.status && data.data){
          this.supplier_list = data.data
        }
        if (this.$route.query.id){
          get_fixedassets_detail(this.$route.query.id).then(data=>{
            if (data.status){
              if (this.$store.state.list_class !== 0){
                let userdata = JSON.parse(localStorage.getItem('userdata'))
                if (userdata.supplier_company_id !== '0'){
                  data.data.supplier = userdata.supplier_company_id
                }
              }
              this.fixedassets_detail = data.data
            }
          })
        }
        else {
          if (this.$store.state.list_class !== 0){
            let userdata = JSON.parse(localStorage.getItem('userdata'))
            if (userdata.supplier_company_id !== '0'){
              this.fixedassets_detail.supplier = userdata.supplier_company_id
            }
          }
        }
      })


    },
    methods: {
      // 添加客戶公司
      on_add_Client_company(){
        let customer_liaisons = []
        let customer_phone = []
        let customer_email = []
        this.contact_person.map(itme=>{
          customer_liaisons.push(itme.customer_liaisons)
          customer_phone.push(itme.customer_phone)
          customer_email.push(itme.customer_email)
        })
        this.add_Client_company.customer_liaisons = customer_liaisons.toString()
        this.add_Client_company.customer_phone = customer_phone.toString()
        this.add_Client_company.customer_email = customer_email.toString()
        add_customer_company(this.add_Client_company).then(data=>{
          console.log(data)
          this.show_add_box = false
          if (this.$store.state.client) {
            MessageBox({
              title: '提示',
              message: data.msg,
            }).then(() => {
              this.edit_state = false
            });
          }
          else {
            this.$alert(data.msg, '提示', {
              confirmButtonText: '确定',
              callback: action => {
                this.edit_state = false
              }
            });
          }
          if(data.status){
            // 获取供应商数据
            getSupplierData().then(data => {
              if (data.status && data.data){
                this.supplier_list = data.data
              }
            })
            this.add_Client_company.company = ''
            this.add_Client_company.address = ''
            this.add_Client_company.tel = ''
            this.add_Client_company.fax = ''
            this.add_Client_company.website = ''
            this.contact_person=[
              {
                customer_liaisons:'',
                customer_phone:'',
                customer_email:'',
              }
            ]
          }
        })
      },
      // 增加聯絡人
      add_contact_person(){
        this.contact_person.push({
          customer_liaisons:'',
          customer_phone:'',
          customer_email:'',
        })
      },
      // 刪除聯絡人
      minus_contact_person(index){
        this.contact_person.splice(index,1)
      },
      return_page(){
        this.$router.push({path: '/orderlist/manage_devices?currentPage=' + this.$route.query.currentPage});
      },
      save_and_edit(){
        this.fixedassets_detail.userCanSee_id = this.fixedassets_detail.userCanSee_id.toString()
        this.fixedassets_detail.users_name = this.$store.state.loginuserdata.username
        add_fixedassets(this.fixedassets_detail).then(data=>{
          // console.log(data)
          if (data.status){
            this.return_page()
          }
          else {
            if (this.fixedassets_detail.userCanSee_id){
              this.fixedassets_detail.userCanSee_id = this.fixedassets_detail.userCanSee_id.split(',')
            }
            if (this.$store.state.client) {
              MessageBox({
                title: '提示',
                message: data.data,
              }).then(() => {
              });
            }
            else {
              this.$alert(data.data, '提示', {
                confirmButtonText: '确定',
                callback: action => {
                }
              });
            }
          }
        })
      }
    },
  }
</script>

<style lang="less" scoped>
  @import "../../assets/less/base";

  html, body, #app {
    height: 100%;
  }

  .contentbox {
    background-color: #f2f2f2;
    width: 100%;
    .signature_box {
      backgrond: #fff;
      width: 80vw;
      padding-top: 10%;
      text-align: center;
      @media (min-width: @screen-xs-max) {
        width: 40vw;
      }
      .itme_box{
        margin-bottom: 20px;
        position: relative;
        .itme{
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 5px;
          >.name{
            width: 30%;
            text-align: left;
          }
        }
        .icon{
          position: absolute;
          right: -30px;
          bottom: 10px;
          cursor: pointer;
        }
      }
      .paymentmethodbut {
        display: flex;
        justify-items: center;
        justify-content: center;
        .mint-button {
          /*margin-right: 20px;*/
          margin: 0 10px;
          cursor: pointer;
        }
      }
    }
    .add_subsidiaries_box{
      height: 80vh;
      overflow: auto;
      .signature_box {
        padding: 50px;
        height: auto;
      }
    }
    .conten {
      margin-top: 52px;
      .personal_settings {
        padding: 20px;
        background: #fff;
        .title {
          text-align: center;
          font-size: 26px;
          margin: 30px auto;
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          width: 80%;
          @media (min-width: @screen-xs-max) {
            width: 20%;
          }
          i {
            font-size: 20px;
            cursor: pointer;
          }
        }
        .form_box{
          padding-bottom: 50px;
          .form_ul{
            width: 100%;
            margin: 0 auto;
            .form_itme{
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 10px;
              >div{
                width: 320px;
              }
              >.select_box{
                /*width: 320px;*/
              }
              .itme_name{
                width: 20%;
              }
              .select_supplier_box{
                display: flex;
                align-items: center;
                color: #3a8ee6;
                cursor: pointer;
                .add{
                  margin-left: 10px;
                }
              }
            }
          }
        }
      }
      .bottom_but {
        position: fixed;
        width: 96%;
        padding: 0 2%;
        display: flex;
        justify-content: flex-end;
        bottom: 30px;
        a{
          color: #fff;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/orderlist_child/equipment_details.vue